module.exports = __webpack_public_path__ + "static/media/idea-icon.bb142244.svg";